module.exports = __webpack_public_path__ + "Server-Unknown.AzureServiceFabricCluster.1ffaa873bd29707ab84c0c3f918bf776.hashedasset.svg";